import {NgModule} from '@angular/core';

// Modules
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared-module';

// Providers
import {AppCatalogService} from './shared/services/app-catalog-service';
import {CatalogService} from './shared/services/catalog-service';
import {ProductCategoriesService} from './shared/services/product-categories-service';
import {ProductsService} from './shared/services/products-service';
import {ProductsPackagesService} from './shared/services/products-packages-service';
import {DynamicPropertiesService} from './shared/services/dynamic-properties-service';
import {CartService} from './shared/services/cart-service';
import {SceneService} from './shared/services/scene-service';
import {GeneratorsService} from './shared/services/generators-service';

 // Mock web api
 import {MockBackend} from '@angular/http/testing';
 import {Http, BaseRequestOptions} from '@angular/http';
 import {ProductCategoriesMockApi} from './shared/services/mock-product-categories-api';
 import {ProductsMockApi} from './shared/services/mock-products-api';

 // Components
import {SummaryPageCmp} from './pages/summary.cmp';
import {CatalogPageCmp} from './pages/catalog.cmp';
//import {ProductCategoriesListCmp} from './shared/components/product-categories/product-categories-list.cmp';
import {ProductCategoriesCmp} from './shared/components/product-categories/product-categories.cmp';
import {ProductCategoryCmp} from './shared/components/product-categories/product-category.cmp';
import {ProductsListCmp} from './shared/components/products/products-list.cmp';
//import {ProductsTinyListCmp} from './shared/components/products/products-tiny-list.cmp';
import {ProductOptionsDropdownCmp} from './shared/components/products/product-options-dropdown.cmp';
import {ProductDetailsCmp} from './shared/components/products/product-details.cmp';
import {GeneratorConfiguratorCmp} from './shared/components/custom-categories/generator-configurator.cmp';
import {SummaryCmp} from './shared/components/summary/summary.cmp';
import {PrintSummaryCmp} from './shared/components/modals/print-summary.cmp';
import {EmailSummaryCmp} from './shared/components/modals/email-summary.cmp';
import {SceneTooltipCmp} from './shared/components/scene/scene-tooltip.cmp';
import {SceneCmp} from './shared/components/scene/scene.cmp';
import {HttpModule} from '@angular/http';
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import {Ng2PageScrollModule} from 'ng2-page-scroll';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:CatalogModule'));

/**
 * Catalog renders the vspa catalog and products
 */
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        SharedModule,
        HttpModule,
        Ng2Bs3ModalModule,
         Ng2PageScrollModule.forRoot()

    ],
    providers: [
        AppCatalogService,
        CatalogService,
        ProductCategoriesService,
        ProductsService,
        ProductsPackagesService,
        DynamicPropertiesService,
        CartService,
        SceneService,
        GeneratorsService,

         // Mock web api
         BaseRequestOptions,
         MockBackend,
         {
             provide: Http,
             deps: [MockBackend, BaseRequestOptions],
             useFactory: (backend, options) => { return new Http(backend, options); }
         },
         ProductCategoriesMockApi,
         ProductsMockApi
    ],
    declarations: [
        SummaryPageCmp,
        CatalogPageCmp,
        //ProductCategoriesListCmp,
        ProductCategoriesCmp,
        ProductCategoryCmp,
        ProductsListCmp,
        //ProductsTinyListCmp,
        ProductOptionsDropdownCmp,
        ProductDetailsCmp,
        GeneratorConfiguratorCmp,
        SummaryCmp,
        PrintSummaryCmp,
        EmailSummaryCmp,
        SceneTooltipCmp,
        SceneCmp
    ],
    exports: [
        SummaryPageCmp,
        CatalogPageCmp,
        //ProductCategoriesListCmp,
        ProductCategoriesCmp,
        ProductDetailsCmp,
        PrintSummaryCmp,
        EmailSummaryCmp,
        SceneCmp
    ]
})
export class CatalogModule {
    constructor() {
        //'Construct catalog module');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/catalog-module.ts